export enum CalculationEntryPointEnum {
  Website = 'website',
  ExternalCalculator = 'externalCalculator',
  Setup = 'setup',
  Management = 'management',
}
